"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTTextArea = void 0;
var React = require("react");
require("./SPOTTextArea.scss");
require("../../../resources/icons/style.css");
var classnames_1 = require("classnames");
var SPOTTextArea = function (props) {
    var register = props.register;
    var error = props.errors && props.errors[props.name];
    var _a = React.useState(0), count = _a[0], setCount = _a[1];
    return (React.createElement("div", { className: (0, classnames_1.default)({
            "textarea-field": true,
            "textarea-success": props.defaultValue && !error,
            "textarea-error": error
        }) },
        React.createElement("textarea", __assign({ id: props.id, defaultValue: props.defaultValue }, register(props.name, {
            required: props.required,
            pattern: props.pattern,
            onChange: function (e) {
                props.onChange(e);
                setCount(e.target.value.length);
            }
        }), { placeholder: props.placeholder, maxLength: props.maxLength, rows: props.rows })),
        props.defaultValue && !error && React.createElement("i", { className: "icon-checkmark" }),
        error && React.createElement("i", { className: "icon-close" }),
        React.createElement("span", { className: "inputErrorMessage" }, error && error.message),
        props.showNumberOfCharacter && (React.createElement("div", { className: "numberOfCharacter" },
            count,
            " / ",
            props.maxLength))));
};
exports.SPOTTextArea = SPOTTextArea;
//# sourceMappingURL=SPOTTextArea.js.map